interface LangTextInter {
    product_name: string;
    tab_product: string;
    tab_bundles?: string;
    tab_support: string;
    tab_specs: string;
    btn_buy: string;
    btn_subscribe?: string;
    prepare_btn?: string;
    btn_beneft?: string;
}
export const LangText: Record<'us' | 'jp' | 'eu' | 'uk' | 'de' | 'fr' | 'es' | 'it' | 'ph' | 'nl', LangTextInter> = {
    us: {
        product_name: 'EcoFlow RAPID',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_subscribe: 'Subscribe',
        btn_buy: 'Buy Now',
        btn_beneft: 'Benefits',
    },
    jp: {
        product_name: 'EcoFlow RAPID',
        tab_product: '概要',
        tab_bundles: 'セット購入',
        tab_support: 'サポート',
        tab_specs: '仕様',
        btn_buy: '今すぐ購入',
    },
    eu: {
        product_name: 'EcoFlow RAPID',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_buy: 'Buy Now',
        btn_subscribe: 'Subscribe',
        prepare_btn: 'Presale',
    },
    uk: {
        product_name: 'EcoFlow RAPID',
        tab_product: 'Product',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_buy: 'Buy Now',
        btn_subscribe: 'Subscribe',
        prepare_btn: 'Presale',
    },
    de: {
        product_name: 'EcoFlow RAPID',
        tab_product: 'Produkt',
        tab_support: 'Support',
        tab_specs: 'Technische Daten',
        btn_buy: 'Jetzt kaufen',
        btn_subscribe: 'Abonnieren',
        prepare_btn: 'Vorverkauf',
    },
    fr: {
        product_name: 'EcoFlow RAPID',
        tab_product: 'Product',
        tab_support: 'Assistance',
        tab_specs: 'Spécifications',
        btn_buy: 'Acheter',
        btn_subscribe: 'S’abonner',
        prepare_btn: 'Prévente',
    },
    es: {
        product_name: 'EcoFlow RAPID',
        tab_product: 'Producto',
        tab_support: 'Asistencia',
        tab_specs: 'Especificaciones',
        btn_buy: 'Comprar ahora',
        btn_subscribe: 'Suscribirse',
        prepare_btn: 'Preventa',
    },
    it: {
        product_name: 'EcoFlow RAPID',
        tab_product: 'Prodotto',
        tab_support: 'Assistenza',
        tab_specs: 'Specifiche',
        btn_buy: 'Acquista ora',
        btn_subscribe: 'Iscriviti',
        prepare_btn: 'Prevendita',
    },
    nl: {
        product_name: 'EcoFlow DELTA 3 Max Plus (2,048Wh)',
        tab_product: 'Product',
        tab_bundles: 'Bundels',
        tab_support: 'Ondersteuning',
        tab_specs: 'Specificaties',
        btn_buy: 'Nu kopen',
    },
    ph: {
        product_name: 'EcoFlow RAPID',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_subscribe: 'Subscribe',
        btn_buy: 'Buy Now',
        btn_beneft: 'Benefits',
    },
};
